import { putSaveAssets } from "../../services/apis";
import { toast } from "react-toastify";
import React from "react";
import { useHistory } from "react-router-dom";

import {
  TEXT,
  IMAGE,
  BUTTON,
  SHAPE,
  SCROLLBAR,
} from "../../Uitls/ComponentType";

const getDOM = (val, animationObj) => {
  let collectComponentInfo = {
    componentType: val.componentType,
    atomId: "",
    atomUrl: "",
    components: {
      ...val.componentStyles,
      keyFrames: val.keyFrames,
      animationObj: animationObj,
      scrollbarComponents: val.scrollbarComponents,
      claimId: val.claimId,
      claimReferences: val.claimReferences,
      claimFootnotes: val.claimFootnotes,
      claimAbbreviation: val.claimAbbreviation,
      footnoteSymbol: val.footnoteSymbol,
      componentId: val.componentId,
      titleId: val.titleId,
      reusableTextId: val.reusableTextId,
      matchTextId: val.matchTextId,
      matchTextReferences: val.matchTextReferences,
      matchTextFootnotes: val.matchTextFootnotes,
      rcClaimIds: val.rcClaimIds,
      matchTextSymbol: val.matchTextSymbol,
      rcSybmols: val.rcSybmols,
      moduleIdIdentifier: val.moduleIdIdentifier,
    },
  };

  switch (val.componentType) {
    case SCROLLBAR:
      collectComponentInfo.components.textComponentType = val.textComponentType;
      collectComponentInfo.components.src =
        val.triImage || val.hexImage || val.pentImage;
      return collectComponentInfo;
    case BUTTON:

    case TEXT:
      collectComponentInfo.components.froalaText = val.froalaText;
      collectComponentInfo.components.textComponentType = val.textComponentType;
      return collectComponentInfo;

    case IMAGE:
      return collectComponentInfo;

    case SHAPE:
      collectComponentInfo.components.textComponentType = val.textComponentType;
      collectComponentInfo.components.src =
        val.triImage || val.hexImage || val.pentImage;

      return collectComponentInfo;

    /*       case default :
        return collectComponentInfo; */
  }
};

export function saveAssets({
  layerCompData,
  assetId,
  animationObject,
  setLayerCompData,
  setundoFlag,
  bannerChanged,
  refBannerChanged,
  setBannerChanged,
  setRefreshed,
  origin,
  bannerName,
  setShowBannerName,
}) {
  // const history = useHistory();
  let finalAssetId = "";
  let assetpagesComponents = [];
  let finalObject = {
    id: "",
    // canvasDimension: {
    //   backgroundColor: canvasDimension?.backgroundColor,
    // }, //IMC-3450(patch call is must for canvasproperties?)
    assetpages: [
      {
        pageIndex: "0",
        pageName: "bannerPAge1",
        assetpagecomponent: assetpagesComponents,
        // fileSizeExceeds: fileSizeExceeds,
      },
    ],
  };

  layerCompData &&
    layerCompData.map((val, index) => {
      // console.log(animationObject[val.id], "animationObject");
      let constructDom = getDOM(val, animationObject[val.id]);
      assetpagesComponents.push(constructDom);
    });

  finalObject.id = "";
  finalAssetId = assetId;
  let msg = saveComponents(
    layerCompData,
    finalAssetId,
    finalObject,
    setLayerCompData,
    setundoFlag,
    bannerChanged,
    refBannerChanged,

    setBannerChanged,
    setRefreshed,
    origin,
    bannerName,
    setShowBannerName
  );
  return msg;
}

function saveComponents(
  layerCompData,
  finalAssetId,
  finalObject,
  setLayerCompData,
  setundoFlag,
  bannerChanged,
  refBannerChanged,

  setBannerChanged,
  setRefreshed,
  origin,
  bannerName,
  setShowBannerName
) {
  // console.log(finalObject, "finalObject")
  return new Promise((resolve) => {
    putSaveAssets(finalAssetId, finalObject, (response, err, errorCode) => {
      const isForbidden = errorCode === 403 || err?.response?.status === 403;

      if (err) {
        if (isForbidden) {
          if (origin !== "hitAreaSave" && origin !== "autoSave") {
            toast.error(
              <div className="notificationText">
                You are not authorized to save the asset
              </div>
            );
          }
        } else if (
          origin !== "backIcon" &&
          origin !== "hitAreaSave" &&
          origin !== "autoSave"
        ) {
          toast.error(<div className="notificationText">Asset not saved</div>);
        }
        // setundoFlag(false);
        setBannerChanged?.(true);
        if (refBannerChanged?.current !== undefined) {
          refBannerChanged.current = true;
        }
        // setRefreshed(false);
        resolve(false);
        return;
      }

      try {
        // let tempLayerCompData = JSON.parse(JSON.stringify(layerCompData));
        // layerCompData.forEach((comp) => {
        //   comp.componentStyles.layerNameSaved = comp.componentStyles.layerName;
        // });// 1634 using dom observer
        if (refBannerChanged?.current !== undefined) {
          refBannerChanged.current = false;
        }
        setShowBannerName?.(bannerName);
        // setundoFlag(true);
        setBannerChanged?.(false);

        // setRefreshed(true);
        // setLayerCompData(tempLayerCompData);
        if (
          origin !== "backIcon" &&
          origin !== "change" &&
          origin !== "hitAreaSave" &&
          origin !== "autoSave"
        ) {
          toast.success(
            <div className="notificationText">Asset saved successfully.</div>
          );
        }
      } catch (saveStateError) {
        console.error("saveAssets post-save state update failed:", saveStateError);
      }

      resolve(true);
    });
  });
}
